import React from 'react';
import {useNavigate} from 'react-router-dom';

import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';

import {FlatButton} from '@pb/kit-component-button';
import {FormSection} from '@pb/kit-component-form-section';
import {Scroll} from '@pb/kit-component-scroll';


import {LoginLinkGeneratorTool} from './admin-tools/login-link-generator/login-link-generator-tool';

import {
    recentlyViewedSection,
    recentlyViewedSectionRecord,
    recentlyViewedSectionRecordsList,
} from './recently-viewed-section.module.styl';

export const AdditionalAdminTools = () => {
    const {hasAccess} = useAdminAccessRight();
    const navigate = useNavigate();

    const canManageEntitlements = hasAccess(ACCESS_RIGHTS.MANAGE_ENTITLEMENTS);
    const canViewManageRolesAndPermissions = hasAccess(ACCESS_RIGHTS.MANAGE_PERMISSIONS_FOR_A_PROFILE);
    const canUseLoginLinkGenerator = hasAccess(ACCESS_RIGHTS.BULK_LOGIN_LINK_GENERATOR);
    const isLiveAgentConfiguratorAllowed = hasAccess(ACCESS_RIGHTS.LIVE_AGENT_CONFIGURATOR);
    const isPlatformAlertBuilderAllowed = hasAccess(ACCESS_RIGHTS.PLATFORM_ALERT_BUILDER);
    const isInternalNotificationAllowed = hasAccess(ACCESS_RIGHTS.INTERNAL_NOTIFICATION_BUILDER);
    const isFullStoryConfiguratorAllowed = hasAccess(ACCESS_RIGHTS.FULL_STORY_CONFIGURATOR);
    const isSsoAccountsAllowed = hasAccess(ACCESS_RIGHTS.SSO_ACCOUNT_STATISTICS);

    const navigateToRoles = () => navigate('/roles');
    const navigateToManageEntitlements = () => navigate('/entitlements');
    const navigateToLiveAgentConfigurator = () => navigate('/live-agent-configurator');
    const navigateToPlatformAlertBuilder = () => navigate('/platform-alert-builder');
    const navigateToFullStoryConfigurator = () => navigate('/full-story-configurator');
    const navigateToInternalNotification = () => navigate('/internal-notification');
    const navigateToSsoAccounts = () => navigate('/sso-accounts');

    return (
        <div>
            <FormSection className={recentlyViewedSection}>
                <div className={recentlyViewedSectionRecordsList}>
                    <Scroll>
                        <ul>
                            {[
                                canViewManageRolesAndPermissions && (
                                    <FlatButton
                                        disabled={false}
                                        onClick={navigateToRoles}>
                                        <strong>
                                            Manage Roles & Permissions
                                        </strong>
                                    </FlatButton>
                                ),
                                canManageEntitlements && (
                                    <FlatButton
                                        key="manage-entitlements"
                                        disabled={false}
                                        onClick={navigateToManageEntitlements}>
                                        <strong>
                                            Manage Entitlements
                                        </strong>
                                    </FlatButton>
                                ),
                                canUseLoginLinkGenerator && (
                                    <LoginLinkGeneratorTool/>
                                ),
                                isLiveAgentConfiguratorAllowed && (
                                    <FlatButton
                                        key="live-agent-configurator"
                                        disabled={false}
                                        onClick={navigateToLiveAgentConfigurator}>
                                        <strong>
                                            Live Agent Configurator
                                        </strong>
                                    </FlatButton>
                                ),
                                isPlatformAlertBuilderAllowed && (
                                    <FlatButton
                                        key="platform-alert-builder"
                                        disabled={false}
                                        onClick={navigateToPlatformAlertBuilder}>
                                        <strong>
                                            Platform Alert Builder
                                        </strong>
                                    </FlatButton>
                                ),
                                isInternalNotificationAllowed && (
                                    <FlatButton
                                        key="internal-notification-builder"
                                        disabled={false}
                                        onClick={navigateToInternalNotification}>
                                        <strong>
                                            Internal Notification Builder
                                        </strong>
                                    </FlatButton>
                                ),
                                isFullStoryConfiguratorAllowed && (
                                    <FlatButton
                                        key="full-story-configurator"
                                        disabled={false}
                                        onClick={navigateToFullStoryConfigurator}>
                                        <strong>
                                            FullStory Configurator
                                        </strong>
                                    </FlatButton>
                                ),
                                isSsoAccountsAllowed && (
                                    <FlatButton
                                        key="sso-accounts"
                                        disabled={false}
                                        onClick={navigateToSsoAccounts}>
                                        <strong>
                                            SSO Self-Service Dashboard
                                        </strong>
                                    </FlatButton>
                                ),
                            ].filter(Boolean).map((tool, i) => (
                                <li key={i} className={recentlyViewedSectionRecord}>
                                    {tool}
                                </li>
                            ))}
                        </ul>
                    </Scroll>
                </div>
            </FormSection>
        </div>
    );
};
